import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ShortFilmCategoryPage from "@/pages/category/shortfilms/page";
import NewsCategoryPage from "@/pages/category/news/page";
import ShortFilmDetailPage from "@/pages/detail/shortfilm/page";
import NewsDetailPage from "@/pages/detail/news/page";
import SearchPage from "@/pages/search/page";
import AboutPage from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/shortfilms",
    element: <ShortFilmCategoryPage />,
  },
  {
    path: "/category/news",
    element: <NewsCategoryPage />,
  },
  {
    path: "/detail/shortfilm/:id",
    element: <ShortFilmDetailPage />,
  },
  {
    path: "/detail/news/:id",
    element: <NewsDetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;